@if (isCustomerEmulationSessionInProgress$ | async) {
  <input
    formcontrolname="customer"
    type="text"
    disabled="true"
    placeholder="{{ customer?.name }}, {{ customer?.uid }}"
    />
    <button (click)="logoutCustomer()">
      {{ 'asm.endSession' | cxTranslate }}
    </button>
  } @else {
    <div class="asm-alert" role="alert">
      {{ 'asm.standardSessionInProgress' | cxTranslate }}
    </div>
  }

